<script>
  export default {
    props: {
      images: {
        required: true,
        type: Array,
      },
    },
    mounted() {
      this.$nextTick(() => {
        const ref = this.$refs["el-carousel"];
        const leftArrow = ref.$el.getElementsByClassName(
          "el-carousel__arrow--left"
        );
        const rightArrow = ref.$el.getElementsByClassName(
          "el-carousel__arrow--right"
        );

        if (
          leftArrow &&
          rightArrow &&
          leftArrow.length > 0 &&
          rightArrow.length > 0
        ) {
          leftArrow[0].setAttribute("aria-label", "Previous slide");
          leftArrow[0].setAttribute("tabindex", "0");
          rightArrow[0].setAttribute("aria-label", "Next slide");
          rightArrow[0].setAttribute("tabindex", "0");
          leftArrow[0].focus();
        }
      });
    },
  };
</script>

<template>
  <el-carousel arrow="always" :autoplay="false" ref="el-carousel">
    <el-carousel-item v-for="(img, inx) in images" :key="inx">
      <img
        v-if="img.uri"
        :src="img.uri"
        :alt="img.alt ? img.alt : 'Carousel image'"
      />

      <span class="caption">
        {{ img.caption }}
      </span>
    </el-carousel-item>
  </el-carousel>
</template>

<style lang="scss" scoped>
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  ::v-deep .el-carousel {
    .--horizontal,
    &__container {
      text-align: center !important;
      height: 70vh !important;
    }
    &__item {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .caption {
        font-size: 16px;
        padding-bottom: 1.2em;
        color: #fff;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
      }
    }
  }
</style>
